import latestEventsFilter from '../partials/bits/latestEventsFilter';

export default {
  init() {
    latestEventsFilter.init();
  },
  finalize() {
    latestEventsFilter.finalize();

    const $mapPopup = $('.map-popup-wrap');
    const $mapPopupImageWrap = $mapPopup.find('.map-popup-image-wrap');
    const $mapPopupImage = $mapPopupImageWrap.find('.map-popup-image');
    var isPanning = false;
    var panningStartX = 0;
    var panningStartY = 0;
    var panningTransformX = 0;
    var panningTransformY = 0;
    var panningScale = 1;

    $(window).on('mousedown touchstart', function(e) {
      if (e.target.classList.contains('map-popup-panner')) {
        // Mouse down
        isPanning = true;

        if (e.pageX && e.pageY) {
          panningStartX = e.pageX - panningTransformX;
          panningStartY = e.pageY - panningTransformY;
        } else {
          panningStartX = e.touches[0].pageX - panningTransformX;
          panningStartY = e.touches[0].pageY - panningTransformY;
        }
      }
    });

    $(window).on('mouseup touchend', function() {
      // Mouse up
      if (isPanning) {
        isPanning = false;
      }
    });

    $(window).on('mousemove touchmove', function(e) {
      if (isPanning) {
        if (e.pageX && e.pageY) {
          panningTransformX = e.pageX - panningStartX;
          panningTransformY = e.pageY - panningStartY;
        } else {
          panningTransformX = e.touches[0].pageX - panningStartX;
          panningTransformY = e.touches[0].pageY - panningStartY;
        }

        $mapPopupImage.css({
          'transform': `translate(${panningTransformX}px, ${panningTransformY}px)`,
        });
      }
    });
    
    // Zoom in
    $mapPopup.find('.map-popup-zoom-in').on('click', function() {
      panningScale *= 1.2;

      $mapPopupImageWrap.css({
        'transform': ` scale(${panningScale})`,
      });
    });
    
    // Zoom out
    $mapPopup.find('.map-popup-zoom-out').on('click', function() {
      panningScale *= 0.8;

      $mapPopupImageWrap.css({
        'transform': ` scale(${panningScale})`,
      });
    });

    // Shrink / close popup
    $mapPopup.find('.map-popup-shrink').on('click', function() {
      $mapPopup.removeClass('open');
      $('body').removeClass('overflow-hidden');
    });

    // Click off popup
    $(window).on('click', function(e) {
      if (e.target.classList.contains('map-popup-wrap')) {
        $mapPopup.removeClass('open');
        $('body').removeClass('overflow-hidden');
      }
    });

    // Expand / open popup
    $('.valleys-map-link').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      $mapPopup.addClass('open');
      $('body').addClass('overflow-hidden');
    });

    // Open filters (mobile)
    $('.mobile-filter-open').on('click', function() {
      $('.filters-wrap').addClass('open');
      $('body').addClass('overflow-hidden');
    });

    // Close filters (mobile)
    $('.mobile-filter-close').on('click', function() {
      $('.filters-wrap').removeClass('open');
      $('body').removeClass('overflow-hidden');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateLatestEvents.js